import React from 'react';
import ChartLoader from '@/pages/dashboard/_charts/ChartLoader';
import DonutChart from '@/pages/dashboard/_charts/DonutChart';
import colors from 'tailwindcss/colors';
import {useEventsContext} from '@/pages/dashboard/EventsContext';
import getStatusChartData from "@/pages/dashboard/_utils/getStatusChartData";

export default function EventStatusYear(props) {
  const {subtitle} = props;
  const {filteredEvents, isLoadingEvents} = useEventsContext();

  if (isLoadingEvents) {
    return (
      <ChartLoader
        title="Event Status"
        subtitle={subtitle || 'For school year'}
      />
    );
  }

  const {series, labels} = getStatusChartData(filteredEvents);

  return (
    <div className="flex flex-col items-start w-full">
      <div className="w-full">
        <DonutChart
          title="Event Status"
          subtitle={subtitle || 'For school year'}
          labels={labels}
          series={series}
          colors={[
            colors.emerald['400'],
            colors.red['400'],
            colors.blue['400'],
            colors.yellow['400']
          ]}
        />
      </div>
    </div>
  );
}
